module.exports = __webpack_public_path__ + "static/media/json.d5cfc49c.svg";